<template>
  <el-form
    :model="member"
    :rules="rules"
    ref="login"
    label-width="0px"
    class="ms-content"
  >
    <el-form-item prop="username">
      <el-input v-model="member.username" placeholder="username">
        <el-button slot="prepend" icon="el-icon-user-solid"></el-button>
      </el-input>
    </el-form-item>
    <el-form-item prop="password">
      <el-input
        type="password"
        placeholder="password"
        v-model="member.password"
        @keyup.enter.native="submitForm()"
      >
        <el-button slot="prepend" icon="el-icon-bank-card"></el-button>
      </el-input>
    </el-form-item>
    <div class="login-btn" style="">
      <el-button :loading="loading" type="primary" @click="submitForm()"
        >登录</el-button
      >
    </div>
    <!-- <p class="login-tips">Tips : 用户名和密码随便填。</p> -->
  </el-form>
</template>

<script>
import { getUserInfo } from "../api/login";
// import cookie from 'js-cookie'
export default {
  data: function () {
    return {
      queryData: this.$route.query,
      member: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      loading: false,
    };
  },
  mounted() {
    console.log(this.queryData)
  },
  methods: {
    submitForm() {
      this.$refs.login.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch("Login", this.member)
            .then(() => {
              this.$store
                .dispatch("GetUserInfoFn")
                .then((res) => {
                  this.loading = false;
                  if (this.queryData.href) {
                    this.$router.replace(this.queryData.href);
                  } else {
                    this.$router.go(-1);
                  }
                  
                  // if (
                  //   res.data.roles[0] === "Aadmin" ||
                  //   res.data.roles[0] === "Auser"
                  // ) {
                  //   console.log('this2', this.$router)
                  //   this.$router.replace("/adaptation");
                  //   // this.$router.push({ path: this.redirect || '/' })
                  // } else if (res.data.roles[0] === "Cadmin") {
                  //   this.$router.push("configuration");
                  // } else if (res.data.roles[0] === "Fadmin") {
                  //   this.$router.push("/forecast");
                  // } else if (res.data.roles[0] === "Radmin") {
                  //   this.$router.push("/recommend");
                  // } else {
                  //   this.$message.error("没有权限！");
                  // }
                })
                .catch(() => {
                  this.loading = false;
                });
              // this.$router.push({ path: this.redirect || '/' })
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          this.$message.error("请输入账号和密码");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.login-btn {
  text-align: center;
  float: center;
}
.login-btn button {
  width: 80px;
  height: 36px;
  margin-bottom: 10px;
}
</style>